// Define field names that should always be disabled in edit mode
export const ALWAYS_DISABLED_FIELDS = [
  'job_id',
  'jobId',
  'ndc',
  'description',
  'qtyOfContainersToFill',
  'qtyPerContainer',
  'qtyUnitsToPackage',
  'confirmedDate',
  'qty_of_containers_to_fill',
  'qty_per_container',
  'qty_units_to_package',
  'confirmed_date'
];

// Define access permissions based on department and role
export const PPS_ACCESS_PERMISSIONS = {
  SaveJobView: [
    { department: 'ppsdep', role: 'basicUser' },
    { department: 'ppsdep', role: 'admin' },
    { department: 'ppsdep', role: 'superUser' },
    { department: 'ppsdep', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  EditJobDetails: [
    { department: 'ppsdep', role: 'basicUser' },
    { department: 'ppsdep', role: 'admin' },
    { department: 'ppsdep', role: 'superUser' },
    { department: 'ppsdep', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' }
  ],

  EditJobOrder: [
    { department: 'ppsdep', role: 'basicUser' },
    { department: 'ppsdep', role: 'admin' },
    { department: 'ppsdep', role: 'superUser' },
    { department: 'ppsdep', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' }
  ],

  // Add UpdateJobStatus permission for ALL roles - everyone can update status
  UpdateJobStatus: [
    { department: 'ppsdep', role: 'basicUser' },
    { department: 'ppsdep', role: 'admin' },
    { department: 'ppsdep', role: 'superUser' },
    { department: 'ppsdep', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    // { department: 'qls', role: 'basicUser' },
    // { department: 'qls', role: 'admin' },
    // { department: 'qls', role: 'superUser' },
    // { department: 'qls', role: 'superAdmin' },

    { department: 'stager', role: 'basicUser' },
    { department: 'stager', role: 'admin' },
    { department: 'stager', role: 'superUser' },
    { department: 'stager', role: 'superAdmin' },

    // { department: 'qa', role: 'basicUser' },
    // { department: 'qa', role: 'admin' },
    // { department: 'qa', role: 'superUser' },
    // { department: 'qa', role: 'superAdmin' },

    { department: 'mo', role: 'basicUser' },
    { department: 'mo', role: 'admin' },
    { department: 'mo', role: 'superUser' },
    { department: 'mo', role: 'superAdmin' },

    { department: 'pa', role: 'basicUser' },
    { department: 'pa', role: 'admin' },
    { department: 'pa', role: 'superUser' },
    { department: 'pa', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  CreateScheduleAttainmentView: [
    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  GetScheduleAttainmentView: [
    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  ViewReferenceTables: [
    { department: 'ppsdep', role: 'basicUser' },
    { department: 'ppsdep', role: 'admin' },
    { department: 'ppsdep', role: 'superUser' },
    { department: 'ppsdep', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  EditReferenceTables: [
    { department: 'ppsdep', role: 'basicUser' },
    { department: 'ppsdep', role: 'admin' },
    { department: 'ppsdep', role: 'superUser' },
    { department: 'ppsdep', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  ProductCalculationsView: [
    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  CleanCalculationsView: [
    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  ScheduleCalculationsView: [
    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  SysproJobsView: [
    { department: 'ppsdep', role: 'basicUser' },
    { department: 'ppsdep', role: 'admin' },
    { department: 'ppsdep', role: 'superUser' },
    { department: 'ppsdep', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ],

  EditSharedFilter: [
    { department: 'packaging', role: 'basicUser' },
    { department: 'packaging', role: 'admin' },
    { department: 'packaging', role: 'superUser' },
    { department: 'packaging', role: 'superAdmin' },

    { department: 'management', role: 'basicUser' },
    { department: 'management', role: 'admin' },
    { department: 'management', role: 'superUser' },
    { department: 'management', role: 'superAdmin' },

    { department: 'developer', role: 'basicUser' },
    { department: 'developer', role: 'admin' },
    { department: 'developer', role: 'superUser' },
    { department: 'developer', role: 'superAdmin' }
  ]
};

/**
 * Checks if a user has access to a specific permission based on their department and role
 */
export const hasPermission = (
  permission: keyof typeof PPS_ACCESS_PERMISSIONS,
  userDepartment: string,
  userRole: string
): boolean => {
  const allowedRoles = PPS_ACCESS_PERMISSIONS[permission] || [];

  return allowedRoles.some(
    access => access.department === userDepartment && access.role === userRole
  );
};

/**
 * Determines if a field should be disabled based on edit mode, field name, and user role
 */
export const isFieldDisabled = (
  fieldName: string,
  userDepartment: string,
  userRole: string,
  isEditMode: boolean = false
): boolean => {
  // Only apply restrictions in edit mode
  if (!isEditMode) {
    return false;
  }

  // These fields are always disabled in edit mode regardless of role
  if (ALWAYS_DISABLED_FIELDS.includes(fieldName)) {
    return true;
  }

  if (fieldName === 'status' && (userDepartment === 'qa' || userDepartment === 'qls')) {
    return false;
  }

  // If the field is "status", allow it for anyone with UpdateJobStatus permission
  if (fieldName === 'status' || fieldName.toLowerCase() === 'status_id') {
    return !canUpdateJobStatus(userDepartment, userRole);
  }

  // For all other fields, they should be disabled unless the user has EditJobDetails permission
  return !canEditJobDetails(userDepartment, userRole);
};
/**
 * Checks if current user can edit job details (beyond just status)
 */
export const canEditJobDetails = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('EditJobDetails', userDepartment, userRole);
};

/**
 * Checks if current user can update job status
 */
export const canUpdateJobStatus = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('UpdateJobStatus', userDepartment, userRole);
};

/**
 * Checks if current user can update job order
 */
export const canUpdateJobOrder = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('EditJobOrder', userDepartment, userRole);
};

/**
 * Checks if current user can add new jobs based on their roles
 */
export const canAddJobs = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('SaveJobView', userDepartment, userRole);
};

/**
 * Checks if current user can create schedule attainments
 */
export const canCreateScheduleAttainment = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('CreateScheduleAttainmentView', userDepartment, userRole);
};

/**
 * Checks if current user can view schedule attainments
 */
export const canViewScheduleAttainment = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('GetScheduleAttainmentView', userDepartment, userRole);
};

/**
 * Checks if current user can view reference tables
 */
export const canViewReferenceTables = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('ViewReferenceTables', userDepartment, userRole);
};

/**
 * Checks if current user can edit reference tables
 */
export const canEditReferenceTables = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('EditReferenceTables', userDepartment, userRole);
};

/**
 * Checks if current user can view product calculations
 */
export const canViewProductCalculations = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('ProductCalculationsView', userDepartment, userRole);
};

/**
 * Checks if current user can view clean calculations
 */
export const canViewCleanCalculations = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('CleanCalculationsView', userDepartment, userRole);
};

/**
 * Checks if current user can view schedule calculations
 */
export const canViewScheduleCalculations = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('ScheduleCalculationsView', userDepartment, userRole);
};

/**
 * Checks if current user can view and import Syspro jobs
 */
export const canViewSysproJobs = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('SysproJobsView', userDepartment, userRole);
};

export const canEditSharedFilter = (userDepartment: string, userRole: string): boolean => {
  return hasPermission('EditSharedFilter', userDepartment, userRole);
};
